(function() {
    /**
     * Add 'Exit' button on first page.
     */

    // Find the active step.
    const formActiveStep = document.querySelector('.gf_step_active');

    // if it is first step or not.
    if (formActiveStep && formActiveStep.classList.contains('gf_step_first')) {
        const exitButton = document.createElement('a');
        const formNextButton = document.querySelector('.gform_next_button');
        exitButton.textContent = 'Exit form';
        // @TODO: href can be dynamic.
        exitButton.setAttribute('href', `${window.location.origin}/event-booking`);
        exitButton.setAttribute('id', 'compound-exit');
        exitButton.setAttribute('class', 'rs-link style--link-arrow');
        formNextButton.parentNode.insertBefore(exitButton, formNextButton);
    } else {
        const compoundExit = document.getElementById('compound-exit');
        if (compoundExit) {
            compoundExit.remove();
        }
    }
})();
